<template>
  <div>
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
      :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Search</label>
          <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">

          </template>
          <div slot="no-body" class="mt-4">
            <vs-table pagination max-items="10" :data="site_list" @sort="handleSort" stripe
              class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th>SITE NAME</vs-th>
                <vs-th>ADDRESS LINE 01</vs-th>
                <vs-th>ADDRESS LINE 02</vs-th>
                <vs-th>PHONE</vs-th>
                <vs-th>EMAIL</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].site_name">
                    {{ data[indextr].site_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line1">
                    {{ data[indextr].address_line1 }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line2">
                    {{ data[indextr].address_line2 }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_telephone">
                    {{ data[indextr].site_telephone }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_email">
                    {{ data[indextr].site_email }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent v-if="data[indextr].is_approved === 3" color="danger">
                      Not Approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 2" color="primary">
                      approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 1" color="warning">
                      Pending Approval
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 0" color="danger">
                      Pending Submission
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3" @click="onClickViewManufacturing(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SupplierRepository = RepositoryFactory.get('supplier');

export default {
  name: 'ManufactureList',
  data() {
    return {
      site_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      supplierId: ''
    }
  },
  props: {
    tenant_id: {
      required: true,
      default: ''
    },
    supplier_id: {
      required: true,
      default: ''
    }
  },
  mixins: [Filter],
  async mounted() {
    // this.$refs.filterCard.isContentCollapsed = true
    // this.$refs.filterCard.maxHeight = '1.5rem'
  },
  methods: {
    async refreshData() {
      this.fetchManufacturingSites()
    },

    async fetchManufacturingSites() {
      this.$vs.loading()
      const { data } = await SupplierRepository.getListOfSupplierManufacturingSites(this.tenant_id, this.supplier_id, this.page, this.filterQuery, 20, this.sort)
      this.site_list = data.data
      this.meta = data.meta
      this.$vs.loading.close()
    },
    onClickViewManufacturing(id) {
      this.$router.push({ path: `/pages/manage-app/suppliers/${this.supplier_id}/manufacturing/${id}` })
    },
    filterQueryUpdate() {
      this.fetchManufacturingSites()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchManufacturingSites()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchManufacturingSites()
      }

    }

  },
}
</script>


<style scoped></style>
